import { useEffect, useRef } from 'react';

import { useDispatch } from 'react-redux';

import { AppDispatch } from '../../store/store';

import { addNotification, type Notification } from '../../store/slices/notification/notificationSlice';

import { socketClient } from '../socketClient';

import { subscribeWhenConnected } from '../utils/subscribeWhenConnected';

interface Props {
    enabled: boolean;
}

export const normalizeRealtimeNotification = (payload: unknown): Notification | null => {
    if (!payload || typeof payload !== 'object') return null;
    const candidate = ('data' in payload && (payload as { data?: unknown }).data)
        ? (payload as { data: unknown }).data
        : payload;
    if (!candidate || typeof candidate !== 'object') return null;
    const value = candidate as Partial<Notification>;
    if (!value.id || !value.title || !value.message || !value.type) return null;
    return {
        id: String(value.id),
        notificationId: String(value.notificationId ?? value.id),
        title: value.title,
        message: value.message,
        type: value.type,
        level: value.level ?? (value.type === 'STOCK_LOW' ? 'WARNING' : 'INFO'),
        isRead: value.isRead ?? false,
        createdAt: value.createdAt ?? new Date().toISOString(),
        assignedAt: value.assignedAt ?? value.createdAt ?? new Date().toISOString(),
    };
};

export const useNotificationsSubscription = ({
    enabled,
}: Props) => {

    const dispatch: AppDispatch = useDispatch();

    const subscribedRef = useRef(false);

    const subscriptionRef = useRef<any>(null);

    useEffect(() => {

        if (!enabled) {
            return;
        }

        if (subscribedRef.current) {
            return;
        }

        subscribeWhenConnected(() => {

            if (subscribedRef.current) {
                return;
            }

            subscribedRef.current = true;

            subscriptionRef.current = socketClient.subscribe(

                '/topic/notifications',

                (message) => {

                    if (!message.body) {
                        return;
                    }

                    try {

                        const payload =
                            JSON.parse(message.body);

                        console.log(
                            '🔔 Notification realtime:',
                            payload
                        );

                        const notification = normalizeRealtimeNotification(payload);
                        if (notification) dispatch(addNotification(notification));

                    } catch (error) {

                        console.error(
                            '❌ Error notification realtime:',
                            error
                        );
                    }
                }
            );

            console.log(
                '✅ Subscription notifications registrada'
            );
        });

        return () => {

            subscriptionRef.current?.unsubscribe();

            subscribedRef.current = false;

            console.log(
                '🛑 Subscription notifications removida'
            );
        };

    }, [enabled]);
};
